import { useMemo } from 'react';
import CodeEditorModule from 'react-simple-code-editor';
import Prism from 'prismjs/components/prism-core';
import 'prismjs/components/prism-markup';
import 'prismjs/components/prism-css';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';

// Same shape as the custom CSS editor in StylesTheme - the module's default
//  export moves depending on how it is bundled
const CodeEditor = CodeEditorModule.default ?? CodeEditorModule;

const LANGUAGES = {
    html: 'markup',
    css: 'css',
    js: 'javascript',
};

/**
 * One of the three code panes in the custom question editor.
 */
const CodePane = ({ language, value, onChange, placeholder, minHeight }) => {
    const grammar = LANGUAGES[language] ?? 'markup';

    const highlight = useMemo(
        () => code => {
            try {
                return Prism.highlight(code, Prism.languages[grammar], grammar);
            } catch {
                // A grammar that didn't load shouldn't take the editor with it
                return code;
            }
        },
        [grammar],
    );

    return (
        <div className="css-editor w-full resize-y font-mono text-xs border rounded bg-white overflow-auto">
            <CodeEditor
                value={value || ''}
                onValueChange={onChange}
                highlight={highlight}
                placeholder={placeholder}
                padding={8}
                style={{ minHeight: minHeight ?? '260px' }}
            />
        </div>
    );
};

export default CodePane;
